module.exports = __webpack_public_path__ + "img/error.2e8d4025.svg";